import { Badge } from '@shared/badge';

const SLATE_PILL = { background: '#f1f5f9', color: '#475569' } as const;

export enum OrderStatus {
  NEW = 'new',
  CONFIRMED = 'confirmed',
  IN_PROGRESS = 'in_progress',
  PAUSED = 'paused',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled',
}

export const OrderStatusList = {
  new: 'New',
  confirmed: 'Confirmed',
  in_progress: 'In Progress',
  paused: 'Paused',
  completed: 'Completed',
  cancelled: 'Cancelled',
};

export const OrderStatusMap: Record<string, Badge<OrderStatus>> = {
  [OrderStatus.NEW]: {
    key: OrderStatus.NEW,
    value: 'New',
    ...SLATE_PILL,
  },
  [OrderStatus.CONFIRMED]: {
    key: OrderStatus.CONFIRMED,
    value: 'Confirmed',
    ...SLATE_PILL,
  },
  [OrderStatus.IN_PROGRESS]: {
    key: OrderStatus.IN_PROGRESS,
    value: 'In Progress',
    ...SLATE_PILL,
  },
  [OrderStatus.PAUSED]: {
    key: OrderStatus.PAUSED,
    value: 'Paused',
    background: '#fef9c3',
    color: '#ca8a04',
  },
  [OrderStatus.COMPLETED]: {
    key: OrderStatus.COMPLETED,
    value: 'Completed',
    background: '#dcfce7',
    color: '#16a34a',
  },
  [OrderStatus.CANCELLED]: {
    key: OrderStatus.CANCELLED,
    value: 'Cancelled',
    background: '#fee2e2',
    color: '#dc2626',
  },
};
